import { useTranslation } from 'react-i18next';

function StepFooter() {
    const { t } = useTranslation();
    return (
        <footer className="fireknife-widget-footer">
            <div className="fireknife-widget-footer__box fireknife-widget-footer__box--1">
                {t('widgetFooter.notice')}
            </div>

            <div className="fireknife-widget-footer__box fireknife-widget-footer__box--2">
                <p>
                    {t('widgetFooter.poweredBy')}{' '}
                    <a href={t('widgetFooter.poweredByLink')} target="_blank">
                        {t('brand')}
                    </a>
                </p>
            </div>
        </footer>
    );
}

export default StepFooter;
